import authApi from './authApi';

export async function submitImageMetadata(originalName, guidFileName, patientIds) {
    try {
        const response = await authApi.post('Imager/Metadata', {
            originalName,
            guidFileName,
            patientIds
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}
 
export async function getPresignedUrl(guidFileName) {
    try {
        const response = await authApi.post('Imager/PresignedUrl', {
            guidFileName
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}
